import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AsyncPipe, CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TextFieldModule } from '@angular/cdk/text-field';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseAlertComponent } from '@fuse/components/alert';
import { TranslocoModule } from '@ngneat/transloco';
import { AtroposModule } from 'atropos-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxLoadingModule } from 'ngx-loading';
import { DomSanitizer } from '@angular/platform-browser';
import { Util } from 'app/models/util';
import { DocumentService } from 'app/services/document.service';
import { RagService } from 'app/services/rag.service';
import { ToastrService } from 'ngx-toastr';
import { Agent, Assistant, CopilotAssetDetails, CopilotMessageUI, CopilotSettings, CopilotSuggestedUiPrompt, MessageResponse, Session } from 'app/models/copilot.model';
import { Asset } from 'app/models/document';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { MatDialog } from '@angular/material/dialog';
import { CitationDialogComponent } from '../citation-dialog/citation-dialog.component';
import {DOCUMENT_SUGGESTED_PROMPTS, FOLDER_SUGGESTED_PROMPTS} from '../../../../../constants'
import { LpmCopilotConfig } from 'app/models/lpm.config';
import { CopilotDrawerComponent } from '../copilot-drawer/copilot-drawer.component';
import { Subscription } from 'rxjs';
import { EventService } from 'app/services/event.service';
import { MatSelectModule } from '@angular/material/select';
import { FileManagerComponent } from '../../file-manager/file-manager.component';

@Component({
  selector: 'app-copilot-chat',
  standalone: true,
  imports: [
    TranslocoModule,
    MatIconModule,
    MatSidenavModule,
    MatButtonModule,
    MatRippleModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonToggleModule,
    NgApexchartsModule,
    NgFor,
    NgIf,
    MatTableModule,
    NgClass,
    CurrencyPipe,
    MatIconModule,
    HttpClientModule,
    MatTooltipModule,
    AtroposModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    TextFieldModule,
    FormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    FuseAlertComponent,
    ScrollingModule,
    NgxLoadingModule,
    MatProgressSpinnerModule,
    CopilotDrawerComponent,
    MatSelectModule
  ],
  templateUrl: './copilot-chat.component.html',
  styleUrl: './copilot-chat.component.scss',
})
export class CopilotChatComponent {
    constructor(
      private rag_service: RagService,
      private _changeDetectorRef: ChangeDetectorRef,
      public util: Util,
      private toastr: ToastrService,
      private sanitizer: DomSanitizer,
      public docService: DocumentService,
      private dialog: MatDialog,
      private eventService: EventService,
      private _fileManagerComponent: FileManagerComponent,

    ) {
    }
      @Input() userDetail: {name:string, email:string} = {name: 'User',email:''};
      @Input() assetId: string = null;
      @Input() copilotConfig: LpmCopilotConfig = new LpmCopilotConfig();
      @Input() selectedAssistant: Assistant = new Assistant();
      @Input() selectedAgent: Agent = new Agent();
      @Output() public close = new EventEmitter();

      @ViewChild('scrollContainer') private scrollContainer!: ElementRef;  
      @ViewChild('chatAreaInput') textareaRef!: ElementRef<HTMLTextAreaElement>;

      private scrollListener!: () => void;
      
      selectedAsset: CopilotAssetDetails | null = new CopilotAssetDetails(); // Selected asset for the chat
      chatMessages: CopilotMessageUI[] = [];
    
      fileUploader: FileUploader;
      files: { name: string; file: File; uploading: boolean }[] = [];
      responseStreamLoading: boolean = false;
      prompt: string = '';
      isScrollDownVisible = false;
      autoScroll = false;
      copiedIndex: number | null = null;
      isLoading:boolean = false;
      suggestedPrompts =  DOCUMENT_SUGGESTED_PROMPTS;
      ChatNote= {
        icon: 'heroicons_solid:document-text',
        title: 'Explore Document',
        description:  "You can ask me about your selected document or choose a suggested prompt below, and I’ll provide relevant insights."
      }
      isFirstRow = true;
      sessions:Session[] = [];
      assetSessionId:string = null;
      subs = new Subscription();
      isFirstMessageReceived:boolean = false;
      askPrompt:string = '';
      drawerConfig = {
        opened: false,
        mode: 'side',
        collapse: true,
      }
      isMessageReponseError:boolean = false;
      settings: CopilotSettings = new CopilotSettings();
      isCopilotAvailable:boolean = false;
      isQAMode:boolean = false;
      showModal = false;
      displayAssistants:boolean = false;
      scopedAssets:CopilotAssetDetails[] = [];

      async ngOnInit(): Promise<void> {
        await this.loadSettings();
        this.isCopilotAvailable = this.isCopilotEnabledWithAtLeastOneAgentOrAssistant();
        if(!this.isCopilotAvailable){
          return;
        }
        this.fileUploader = this.util.fileUploadToRag(this.assetId);
        this.configAfterFileUpload();
        this.loadAssetDetail();
        this.addSubscriptions();
        this.handleCitationClick();

        await this.getAndSetAssetSessions();
        this.selectDefaultAssistant();

        this.setQAFlag();
        if (!this.isQAMode) {
          await this.createNewSession();
          this.sendMessage();
        }

      }

      ngAfterViewInit(): void {
        this.addScrollListener();
        setTimeout(() => {
          this.drawerConfig.opened = true;
        }, 100);
      }

      ngAfterViewChecked() {
        this.scrollListener();
        if (this.autoScroll) {
          this.scrollToBottom();
        }
      }
    
      loadAssetDetail() {
        this.rag_service.getAssetDetails(this.assetId).then((res) => {
          const asset = this.docService.getData(res);
          this.selectedAsset = asset;
          if(this.selectedAsset.type === 'FOLDER') {
            this.suggestedPrompts = FOLDER_SUGGESTED_PROMPTS;
            this.ChatNote.title = 'Explore Folder';
            this.ChatNote.description =  "You can ask me about the files in your selected folder or choose a suggested prompt below, and I’ll help with relevant insights.";
            this.ChatNote.icon = 'heroicons_solid:folder';
            this.loadAssetScopedFiles();
          }
        }).catch(error => {
          console.error('Error loading file data:', error);
          this.toastr.error('Failed to load file data', error);
        });
      }
      FolderFiles:Asset[] =[] 
    
      loadAssetMessagesBySessionId(): void {
        this.isLoading = true;

        this.rag_service.getSessionMessages(this.assetSessionId).then(res => {
          const assetMessagesHistory: MessageResponse[] = this.rag_service.getData(res);
    
          this.chatMessages = (assetMessagesHistory || []).map((msg: MessageResponse) => ({
            id: msg.id,
            sender: msg.role === 'user' ? 'user' : 'copilot',
            message: this.util.getMarkedContent(msg.content,msg.details),
            messageText: msg.content,
            timestamp: new Date().toLocaleTimeString(),
            details:msg.details || [],
            profilePicture: msg.role === 'user'
              ? 'assets/images/avatars/jrl_photo.jpg'
              : 'assets/images/avatars/copilot_avatar.png',
            exportOptions: msg.exportOptions || null

          }));
         }).catch(error => {
          this.toastr.error('Failed to load asset history');
          console.error('Error loading file data:', error);
         }).finally(() => {
          setTimeout(() => {
            this.scrollToBottom();
            this._changeDetectorRef.detectChanges(); // Trigger change detection to update the view
            this._changeDetectorRef.markForCheck(); // Mark for check to ensure the view updates correctly
             });
        this.isLoading = false;

        });
    
      }

      createNewSession(){
        return new Promise((resolve,reject)=>{
          this.isLoading = true;
          const isAgent:boolean = this.selectedAssistant && this.selectedAgent.id ? true : false;
          const id = isAgent ? this.selectedAgent.id : this.selectedAssistant.id;
          this.rag_service.createAssetSession(this.assetId,id,this.copilotConfig,isAgent).then(res=>{
            this.assetSessionId = this.rag_service.getData(res);
              this.isFirstMessageReceived = false;
              this.chatMessages = [];
              this._changeDetectorRef.detectChanges();
              this._changeDetectorRef.markForCheck();
              this.displayAssistants = false;
              resolve(null)
          }).catch(error=>{
            console.log(error)
          }).finally(()=>{
            this.isLoading = false;
            reject(null)
          })
        })
       
      }

      getAndSetAssetSessions(){
        return new Promise((resolve,reject)=>{
          this.rag_service.getAllSessionsByAssetId(this.assetId).then(res=>{
            this.sessions = this.rag_service.getData(res);
            resolve(this.sessions)
          }).catch(error=>{
            console.log(error)
            reject(null)
          })
        })
      }

      loadAssetSessions(onlyUpdateSessions: boolean = false){
        this.rag_service.getAllSessionsByAssetId(this.assetId).then(res=>{
          this.sessions = this.rag_service.getData(res);
          if(onlyUpdateSessions){
            return;
          }
          if(this.sessions.length > 0 ){
            this.assetSessionId = this.sessions[0].id;
            this.loadAssetMessagesBySessionId();
          }
          else{
            this.setNewChat();
          }
          
        }).catch(error=>{
          console.log(error)
        })
      }

      async sendMessage() {
        this.fileUploader.queue = [];
        this.fileUploader.clearQueue();
        const messagesHeight = 300;
        const assistantMessage: CopilotMessageUI = {
          id: Date.now().toString(),
          sender: 'copilot',
          message: this.sanitizer.bypassSecurityTrustHtml(
            `<div style="height:${messagesHeight}px; font-size:14px;" class="flex items-start">
            <div class="flex items-center">
              <span class=" text-gray-900 dark:text-white" > Generating Response </span>
               <div class="inline-flex  gap-1 px-3  ml-2">
                  <span class="copilot-response-dot"></span>
                  <span class="copilot-response-dot"></span>
                  <span class="copilot-response-dot"></span>
               </div>
            </div>
            
             </div>`
          ) as any,
          messageText: 'Generating Response',
          timestamp: new Date().toLocaleTimeString(),
          profilePicture: 'assets/images/avatars/jrl_photo.jpg',
          details:[],
          exportOptions:null
        
        };

        this.chatMessages.push(assistantMessage);
        
        this._changeDetectorRef.detectChanges(); // Trigger change detection to update the view
        this._changeDetectorRef.markForCheck(); // Mark for check to ensure the view updates correctly
        this.scrollToBottom();
      
        const askContent = this.askPrompt;
        this.askPrompt = "";
        setTimeout(() => {
          this.adjustTextarea(5); // Reset textarea height after sending message
        });
      
        try {
          this.responseStreamLoading = true;
          const payload = this.isQAMode ? { content: askContent }: {content:''};
          const isAgent = this.selectedAgent && this.selectedAgent.id ? true : false;
          const response = await this.rag_service.askInSession(this.assetSessionId, payload,isAgent);
          const result:MessageResponse = this.rag_service.getData(response);
          const answerContent = result.content;
          assistantMessage.id = result.id;
          assistantMessage.timestamp = new Date().toLocaleTimeString();
          assistantMessage.details = result.details || [];
          assistantMessage.details = result.details || [];
          assistantMessage.messageText = answerContent;
          assistantMessage.exportOptions = result.exportOptions || null;

          if(!this.isFirstMessageReceived){
            this.isFirstMessageReceived = true;
            this.loadAssetSessions(true);
          }

          await this.animateMessageTyping(assistantMessage, answerContent,result.details);
      
        } catch (error) {
          this.setErrorResponse();
          this._changeDetectorRef.detectChanges(); // Trigger change detection to update the view
        } finally {
          this.responseStreamLoading = false;
          this.displayAssistants = false;
        }
      }
    
      async animateMessageTyping(
        message: CopilotMessageUI,
        fullText: string,
        details: MessageResponse['details']) {
        const maxDuration = 3000;    // ms - maximum total typing time
        const baseCharMs = 10;       // ms per char for "natural" short messages
        const minInterval = 16;      // ms minimum interval between frames (~60fps)
      
        const totalChars = fullText.length;
        if (totalChars === 0) {
          message.message = this.util.getMarkedContent('');
          this._changeDetectorRef.detectChanges();
          return;
        }
      
        const naturalDuration = totalChars * baseCharMs;
      
        // Decide whether to type char-by-char or batch to meet maxDuration
        let batchSize: number;
        let intervalMs: number;
      
        if (naturalDuration <= maxDuration) {
          // Short message: keep per-character feel
          batchSize = 1;
          intervalMs = baseCharMs;
        } else {
          // Long message: compute an appropriate number of steps (frames)
          // so we finish within maxDuration while keeping interval >= minInterval.
          const maxFrames = Math.max(1, Math.floor(maxDuration / minInterval));
          const steps = Math.min(totalChars, maxFrames); // <-- using `steps` now
          batchSize = Math.ceil(totalChars / steps);
          const actualSteps = Math.ceil(totalChars / batchSize);
          intervalMs = Math.max(minInterval, Math.floor(maxDuration / actualSteps));
        }
      
        // Animate by slicing chunks of `batchSize`
        for (let i = 0; i < totalChars; i += batchSize) {
          const sliceEnd = Math.min(i + batchSize, totalChars);
          const displayedText = fullText.slice(0, sliceEnd);
          message.message = this.util.getMarkedContent(displayedText,details);
          this._changeDetectorRef.detectChanges();
          await this.delay(intervalMs);
        }
      
        // Ensure final content is the full text (guard against rounding)
        message.message = this.util.getMarkedContent(fullText,details);
        this._changeDetectorRef.detectChanges();
      }
      
      delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      
      setUserMessage() {
        this.responseStreamLoading = true;
        const userMessage: CopilotMessageUI = {
          id: Date.now().toString(),
          sender: 'user',
          message: this.askPrompt,
          messageText: this.askPrompt,
          timestamp: new Date().toLocaleTimeString(),
          profilePicture: 'assets/images/avatars/jrl_photo.jpg',
          details: [],
          exportOptions:null
        }
        if(this.isQAMode){
        this.chatMessages.push(userMessage);
      }
        this._changeDetectorRef.detectChanges(); // Trigger change detection to update the view;
        this._changeDetectorRef.markForCheck(); // Mark for check to ensure the view updates correctly
      }
    
      async onSendClick() {
        this.askPrompt = this.prompt;
        this.prompt = '';
        if(this.askPrompt.trim() === '' && !this.isQAMode) {
          return;
        }
        
        if(!this.assetSessionId){
          await this.createNewSession();
        }
        this.setUserMessage();
        this.sendMessage();
      
      }
    
      onFileSelected(event: any) {
    
        const fileList: FileList = event.target.files;
        Array.from(fileList).forEach(file => {
          const fileItem = {
            name: file.name,
            file,
            uploading: true,
          };
          this.files.push(fileItem);
    
          this.uploadFile(fileItem.file);
        });
    
        event.target.value = '';
      }
    
      uploadFile(file: any) {
        const fileItem = new FileItem(this.fileUploader, file, { url: "" });
        this.fileUploader.queue.push(fileItem);
        this.fileUploader.uploadAll();
      }
    
      /**
          * Configures the file uploader after a file upload.
          */
      configAfterFileUpload() {
        this.fileUploader.onAfterAddingFile = () => {
        };
    
        this.fileUploader.onProgressItem = () => {
        };
    
        this.fileUploader.onCompleteItem = (item: FileItem, response: any, status: any, headers: any) => {
          try {
            const res = JSON.parse(response);
            item.isError = res.status == "ERROR";
            item.isSuccess = !item.isError
    
          }
    
          catch (Error: any) {
            if (this.util.InvalidErrorResponse(Error.message)) {
              throw ("Invalid Error Response")
            }
          }
    
        };
    
        this.fileUploader.onSuccessItem = () => {
        };
    
        this.fileUploader.onCompleteAll = () => {
        };
    
        this.fileUploader._onErrorItem = (item: FileItem, response: string, status, headers) => {
        }
    
        this.fileUploader.onErrorItem = (item, response, status) => {
        }
    
        this.fileUploader.onProgressAll = () => {
        }
    
      }
    
      removeFile(file: FileItem) {
        file.remove();
      }
    
      onBackClicked() {
        this.close.emit(null);
      }

      onEnterKey(event: KeyboardEvent) {
        // Submit on Enter only if Shift is not held and there is text in the prompt
        this.askPrompt = this.prompt;
        if (!event.shiftKey && this.askPrompt.trim()) {
          event.preventDefault(); // Prevent newline
          this.onSendClick();
        }
      }
   
      copyToClipboard(text: string, index: number) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.copiedIndex = index;

            // Reset after 2 seconds
            setTimeout(() => {
              if (this.copiedIndex === index) {
                this.copiedIndex = null;
              }
            }, 2000);
          })
          .catch(err => {
            console.error('Copy failed:', err);
          })
      }

      scrollToBottom(): void {
        try {
          const el = this.scrollContainer.nativeElement;
          el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth'
          });
        } catch (err) {
          console.error('Scroll error:', err);
        }
      }

      addScrollListener() {
        const el = this.scrollContainer?.nativeElement;
        if (!el) return;

        this.scrollListener = () => {
          const threshold = 20;
          const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
          this.isScrollDownVisible = distanceFromBottom > threshold;
        };

        el.addEventListener('scroll', this.scrollListener);
      }

      removeScrollListener() {
        const el = this.scrollContainer?.nativeElement;
        if (el && this.scrollListener) {
          el.removeEventListener('scroll', this.scrollListener);
        }
      }

      handleCitationClick() {
        const chatContainer = document.querySelector('.chat-container');

        if (chatContainer) {
          chatContainer.addEventListener('click', (e: Event) => {
            const target = e.target as HTMLElement;
            const citationEl = target.closest('[data-ref-index]') as HTMLElement;

            if (!citationEl) {
              return;
            }
            const refIndex = Number(citationEl.getAttribute('data-ref-index'));
            const msgIndex = Number(citationEl.closest('[data-msg-index]')?.getAttribute('data-msg-index'));
            const message = this.chatMessages[msgIndex];
            if (message?.details?.[refIndex]) {
              const ref = message.details[refIndex];
              this.dialog.open(CitationDialogComponent, {
                width: '600px',
                data: { documentName: `${ref.documentName}`,pageNumbers:[ref.pageNumbers] ,content: ref.content},
              });
            }
          });
        }
      }

      onPromptClick(prompt:CopilotSuggestedUiPrompt) {
        const promptAssistant = this.settings.assistants.find(pa=>pa.code==prompt.rag_code && pa.enabled );
        if(promptAssistant){
          this.selectedAssistant = promptAssistant;
        }
        
        this.prompt = prompt.description;
        this.onSendClick();
      }

      adjustTextarea(maxRows: number) {
        const textarea = this.textareaRef?.nativeElement ?? null;
        if(textarea == null) return; 
        const lineHeight = parseInt(getComputedStyle(textarea).lineHeight || '20', 10);
    
        textarea.style.height = 'auto';
        const newHeight = textarea.scrollHeight;
    
        const maxHeight = lineHeight * maxRows;
        textarea.style.height = Math.min(newHeight, maxHeight) + 'px';
    
        // detect first row
        this.isFirstRow = textarea.scrollHeight <= lineHeight * 1.5;
      }
      
      setErrorResponse() {
        this.chatMessages.splice(this.chatMessages.length -1)
        this.isMessageReponseError = true;
      }

      addSubscriptions() {

        this.subs.add(
          this.eventService.changeCurrentAssetSession.subscribe((session:Session) => {
            const sessionId = session.id;
          
            if (sessionId && this.assetSessionId !== sessionId) {
              this.setNewChat();
              this.assetSessionId = sessionId;
              this.loadAssetMessagesBySessionId();
              this.selectedAssistant = this.settings.assistants.find(a=>a.ragAssistantId == session.assistantAgentId) ?? new Assistant();
              this.selectedAgent = this.settings.agents.find(a=>a.ragAgentId == session.assistantAgentId) ?? new Agent();
              if(!this.selectedAssistant.id){
                this.selectDefaultAssistant();
              }
              this.setQAFlag();
            }
          }
          )
        );

        this.subs.add(
          this.eventService.newCopilotChat.subscribe(() => {
            this.setNewChat();
          }
          )
        );

        this.subs.add(
          this.eventService.deleteCopilotAssetSession.subscribe(() => {
           this.setNewChat();
          }
          )
        );
      }

      setNewChat(){
        this.chatMessages = [];
        this.assetSessionId = null;
        this.isFirstMessageReceived = false;
        this.isScrollDownVisible = false;
        this.prompt = '';
        this.isLoading = false;
        this.isFirstRow = true;
        this.isMessageReponseError = false;
        this.selectedAssistant = new Assistant();
        this.selectedAgent = new Agent();
        this.selectDefaultAssistant();
        this.setQAFlag();
        this.displayAssistants = true;
      }

      retryMessage(){
        this.isMessageReponseError = false;
        
        const messagesLength = this.chatMessages.length;
        const lastUserMessage = this.chatMessages[messagesLength - 1]; // Get the last user message
        if(lastUserMessage.sender == 'user'){
          this.chatMessages.splice(messagesLength - 1); // Remove the last user and  copilot message
        }

        this.prompt = lastUserMessage.messageText;
        this.onSendClick();
      }

      loadSettings(){
        return new Promise((resolve,reject)=>{
          this.rag_service.getSettings().then((response) => {
            this.settings = this.rag_service.getData(response);
            if (this.settings) {
              resolve(null)
            }
          }
          ).catch(err => {
            console.error('Error fetching RAG settings', err);
          }
          );
        })
     
      }

  async selectAssistant(agentAssistant: Assistant | Agent = null) {

    this.setNewChat();
    this.displayAssistants = false;
    if (agentAssistant) {
      if ('assistantType' in agentAssistant) {
        this.selectedAssistant = agentAssistant as Assistant;
        this.selectedAgent = new Agent();
        this.isQAMode = this.selectedAssistant.assistantType == 'QA';
      }
      else if ('agentType' in agentAssistant) {
        this.selectedAgent = agentAssistant as Agent;
        this.selectedAssistant = new Assistant();
        this.isQAMode = this.selectedAgent.agentType == 'QA';
      }
    }

    this.setQAFlag();

    if (!this.isQAMode) {
      await this.createNewSession();
      this.sendMessage();
    }
  }

      selectDefaultAssistant(){

        const isAssistantSelected = this.selectedAssistant && this.selectedAssistant.id;
        const isAgentSelected = this.selectedAgent && this.selectedAgent.id;
        if(!isAssistantSelected && !isAgentSelected){
          const QAAssistant =  this.settings.assistants.find(a=>a.code == 'DefaultQA' && a.enabled);
          this.selectedAssistant = QAAssistant || new Assistant();
        }
     
      }

      get copilotDes() {
        const otherAssitants = this.settings.assistants.findIndex(assitant => assitant.enabled && assitant.assistantType == 'Task') !== -1 ? true : false;
        const QAAssistants = this.settings.assistants.findIndex(assitant => assitant.enabled && assitant.assistantType == 'QA') !== -1 ? true : false;
        const bothTypes = otherAssitants && QAAssistants;
        const onlyOther = otherAssitants && !QAAssistants;
        const onlyQA = !otherAssitants && QAAssistants;

        switch (true) {
          case bothTypes:
            return `Select an assistant to get started or ask a question below.`
          case onlyOther:
            return `Select an assistant to get started.`
          case onlyQA:
            return `You can ask me questions about your selected document or folder, and I’ll provide relevant answers based on its content.`
          default:
            return `You can ask me questions about your selected document or folder, and I’ll provide relevant answers based on its content.`
        }

      }

      setQAFlag(){
        const isQAAssitant = this.selectedAssistant.assistantType == 'QA';
        const isQAAgent = this.selectedAgent.agentType == 'QA';
        this.isQAMode = isQAAssitant || isQAAgent;
      }

      isCopilotEnabledWithAtLeastOneAgentOrAssistant():boolean{
        if(!this.settings.ragEnabled){
          this.toastr.error('Copilot is disabled. Please contact your administrator.' );
          return false;
        }
        const isOneAssistantEnabled = this.settings.assistants.some(a=>a.enabled);
        const isOneAgentEnabled = this.settings.agents.some(a=>a.enabled);

        const agentOrAssitantEnabled:boolean = isOneAgentEnabled || isOneAssistantEnabled;
        if(!agentOrAssitantEnabled){
          this.toastr.error('No assistants/agents are enabled. Please contact your administrator.' );
          return false;
        }

        return true
      }

      viewFile(file: CopilotAssetDetails) {
        this.util.viewFile(file).then( res => {{
          console.log('File opened successfully');
        }})
      }

      toggleModal(): void {
        this.showModal = !this.showModal;
      }

      exportMessageData(message: CopilotMessageUI) {
        const data = {id:message.id}
        message.exporting = true;
        this.rag_service.exportData(this.assetSessionId, data).then(res=>{
        const data :MessageResponse= this.rag_service.getData(res); 
        const jsonData = JSON.parse(data.content);
        message.exporting = false;
        this.eventService.createEntityFromCopilot.emit(jsonData);
        }).catch(error=>{
          console.log(error)
          this.toastr.error(error?.message || 'Failed to export message data', 'Error');
          message.exporting = false;
        })
      }

      loadAssetScopedFiles(){
        if(this.selectedAsset.type !== 'FOLDER'){
          return;
        }
        this.rag_service.getAssetScopedAssets(this.assetId).then(res=>{
          this.scopedAssets = this.rag_service.getData(res);
        }).catch(error=>{
          console.log(error)
        })
      }

      ngOnDestroy() {
            this.removeScrollListener();
            this.subs.unsubscribe();
      }    

}
